import React from 'react';
import { cn } from '@express-labs/raven-tools';
import s from '../Icon.scss';
import { IconV1Props } from '../Icon';

const CreditCard: React.FC<IconV1Props> = ({ icon }) => (
  <svg
    className={cn(s.svg, 'svg-icon--credit-card')}
    viewBox="0 0 30 20"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    data-icon={icon}
  >
    <g
      id="icn_genericCreditCard"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g fill="#000000" fillRule="nonzero" id="Combined-Shape">
        <path d="M30,4.44444444 L0,4.44444444 L0,2 C-1.3527075e-16,0.8954305 0.8954305,2.02906125e-16 2,0 L28,0 C29.1045695,-2.16501571e-15 30,0.8954305 30,2 L30,4.44444444 Z M30,7.77777777 L30,18 C30,19.1045695 29.1045695,20 28,20 L2,20 C0.8954305,20 1.3527075e-16,19.1045695 0,18 L0,7.77777777 L30,7.77777777 Z" />
      </g>
    </g>
  </svg>
);

export default CreditCard;
